import { IconButtonProps, IconButton as MuiIconButton, Tooltip } from '@mui/material';
import { FC } from 'react';

type CustomIconButtonProps = IconButtonProps & {
  tooltip?: string;
};

/**
 * Custom IconButton with built in tooltip
 * @param props
 * @returns
 */
const IconButton: FC<CustomIconButtonProps> = ({ tooltip, children, ...props }) => {
  return tooltip && !props.disabled ? (
    <Tooltip title={tooltip} placement='top' arrow>
      <MuiIconButton {...props}>{children}</MuiIconButton>
    </Tooltip>
  ) : (
    <MuiIconButton {...props}>{children}</MuiIconButton>
  );
};

export default IconButton;
